import React, { Fragment, useCallback, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '#app/hooks/useAppStore';
import {
  FirstHeaderContainer,
  HeaderIcon,
  HeaderLogo,
  HeaderRightContainer,
  HeaderShadow,
  LogoRow,
  LogoutContainer,
  MenuContainer,
  Points,
  Swan,
  Warning,
} from './styles';
import LogoWithTrademark from '#app/components/LogoWithTrademark';
import BurgerMenu from './components/BurgerMenu';
import MobileMenu from './components/MobileMenu';
// import { getUserAccounts } from '#app/actions/account';
import {
  handleClient,
  // handleCurrency,
  searchClients,
} from '../../../actions/interface';
import { getUser, logout } from '../../../actions/auth';
import {
  finishScenario,
  handleEndDemo,
  handleEndTutorial,
  // handleStartDemo,
  // handleStartTutorial,
  startScenario,
} from '../../../actions/scenario';
import { Text } from 'finhelper';
import DropdownContent from './DropdownContent/DropdownContent';
import NotificationContent from '#app/interface/cabinet/header/components/NotificationContent';
import AccountingDropdown from '#app/interface/cabinet/header/components/AccountingDropdown';
import IncomeDropdown from '#app/interface/cabinet/header/components/IncomeDropdown';
import PlanDropdown from '#app/interface/cabinet/header/components/PlanDropdown';
import InvestingDropdown from '#app/interface/cabinet/header/components/InvestingDropdown';
import TeachDropdown from '#app/interface/cabinet/header/components/TeachDropdown';
import ConfigDropdown from '#app/interface/cabinet/header/components/ConfigDropdown';
import ProfileDropdown from '#app/interface/cabinet/header/components/ProfileDropdown';
import { handleRouteClick } from '#app/interface/cabinet/header/Dropdown/utils/handleRouteClick';
import { isManager } from '#app/helpers/isManager';
import { routes } from '#app/constants/routes';
import { useQueryClient } from '@tanstack/react-query';
import refreshAllUserData from '#app/helpers/refreshAllUserData';
import { InputContainer, Search } from 'finform';

const Header = ({ isMaintenance = false }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const i18n = useAppSelector((s) => s.i18n);
  const data = useAppSelector((s) => s.auth.data);
  const client = useAppSelector((s) => s.interfaceComponents.client);
  const clients = useAppSelector((s) => s.interfaceComponents.clients);
  const searchedClients = useAppSelector((s) => s.interfaceComponents.searchedClients);
  const clientLoading = useAppSelector((s) => s.interfaceComponents.clientLoading);
  const currencyLoading = useAppSelector((s) => s.interfaceComponents.currencyLoading);
  const accountLoading = useAppSelector((s) => s.account.accountLoading);
  const formLoading = useAppSelector((s) => s.scenario.formLoading);
  const incomeTypesLoading = useAppSelector((s) => s.interfaceComponents.incomeTypesLoading);
  const spendTypesLoading = useAppSelector((s) => s.interfaceComponents.spendTypesLoading);
  const tagsLoading = useAppSelector((s) => s.interfaceComponents.tagsLoading);
  const subcategoriesLoading = useAppSelector((s) => s.interfaceComponents.subcategoriesLoading);
  const demo = useAppSelector((s) => s.scenario.demo);
  const tutorial = useAppSelector((s) => s.scenario.tutorial);
  const notifications = useAppSelector((s) => s.interfaceComponents.notifications);

  const [form, setForm] = useState({
    item: client ? client : null,
    item_id: client ? client.id : '',
    item_search: client ? Text.fio(client) : '',
  });

  const [searchLoading, setSearchLoading] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useMemo(() => {
    setForm({
      item: client ? client : null,
      item_id: client ? client.id : '',
      item_search: client ? Text.fio(client) : '',
    });
  }, [client]);

  const isLoaded =
    !clientLoading &&
    !currencyLoading &&
    !accountLoading &&
    !formLoading &&
    !incomeTypesLoading &&
    !spendTypesLoading &&
    !tagsLoading &&
    !subcategoriesLoading;

  const handleMenu = (e, url) => {
    e.preventDefault();

    handleRouteClick(url, client, data, navigate);
  };

  // Обработчик поиска с debounce
  const handleSearchClients = useCallback(
    (searchText) => {
      setSearchLoading(true);

      dispatch(
        searchClients({
          search: searchText,
          callback: () => {
            setSearchLoading(false);
          },
        })
      );
    },
    [dispatch]
  );

  // Используем searchedClients если они есть, иначе пустой массив
  const clientsToShow = clients || [];

  return (
    <Fragment>
      <HeaderShadow>
        <FirstHeaderContainer>
          <HeaderLogo>
            <LogoRow>
              <Swan to={routes.ROOT} />
              <LogoWithTrademark variant="alternate" to={routes.ROOT} />
            </LogoRow>
          </HeaderLogo>
          {!isMaintenance && (
            <>
              <BurgerMenu onClick={() => setMobileMenuOpen(!mobileMenuOpen)} />
              <MenuContainer>
                <AccountingDropdown
                  i18n={i18n}
                  handleMenu={handleMenu}
                  data={data}
                  url={location.pathname}
                />
                <IncomeDropdown
                  i18n={i18n}
                  handleMenu={handleMenu}
                  data={data}
                  url={location.pathname}
                />
                <PlanDropdown
                  i18n={i18n}
                  handleMenu={handleMenu}
                  data={data}
                  url={location.pathname}
                />
                <InvestingDropdown
                  i18n={i18n}
                  handleMenu={handleMenu}
                  data={data}
                  url={location.pathname}
                />
                <ConfigDropdown
                  i18n={i18n}
                  handleMenu={handleMenu}
                  data={data}
                  url={location.pathname}
                />
              </MenuContainer>
              <HeaderRightContainer>
                {isManager(data) && (
                  <InputContainer>
                    <Search
                      placeholder={'Клиент'}
                      id="client_id"
                      name="client_id"
                      search={form.item_search}
                      onSearch={(searchText) => {
                        setForm({
                          ...form,
                          item_search: searchText,
                        });

                        // Вызываем поиск только если введено минимум 2 символа
                        if (searchText && searchText.length >= 2) {
                          handleSearchClients(searchText);
                        }
                      }}
                      loading={searchLoading || (!isLoaded && form.item)}
                      disabled={!isLoaded && form.item}
                      value={form?.id}
                      onChange={(item) => {
                        if (item) {
                          setForm({
                            item: item,
                            item_id: item.id,
                            item_search:
                              Text.fio(item) + (item.email ? ' (' + item.email + ')' : ''),
                          });

                          dispatch(handleClient({ client: item, data }));
                          void refreshAllUserData({
                            queryClient,
                            dispatch,
                            client: item,
                          });
                          dispatch(getUser());
                        } else {
                          setForm({
                            item: null,
                            item_id: '',
                            item_search: '',
                          });
                        }
                      }}
                      options={clientsToShow?.map((user) => {
                        /**
                         * @type {Client} client
                         */

                        return {
                          ...user.attributes,
                          name: Text.fio(user) + (user.email ? ' (' + user.email + ')' : ''),
                        };
                      })}
                    />
                  </InputContainer>
                )}
                <LogoutContainer>
                  {client?.points > 0 && (
                    <Points id="user-points">{client.points ? client.points : 0}</Points>
                  )}
                  {!isManager(data) && (
                    <TeachDropdown
                      demo={demo}
                      tutorial={tutorial}
                      i18n={i18n}
                      finishScenario={(payload) => dispatch(finishScenario(payload))}
                      handleEndDemo={() => dispatch(handleEndDemo())}
                      handleEndTutorial={() => dispatch(handleEndTutorial())}
                      startScenario={(payload) => dispatch(startScenario(payload))}
                    />
                  )}
                  <DropdownContent content={<NotificationContent notifications={notifications} />}>
                    <HeaderIcon>
                      <Warning src={require('../../../assets/icons/warning-2.svg')} alt="" />
                    </HeaderIcon>
                  </DropdownContent>
                  <ProfileDropdown i18n={i18n} logout={(payload) => dispatch(logout(payload))} />
                </LogoutContainer>
              </HeaderRightContainer>
            </>
          )}
        </FirstHeaderContainer>
      </HeaderShadow>
      {!isMaintenance && (
        <MobileMenu
          modalVisible={mobileMenuOpen}
          closeMenu={() => setMobileMenuOpen(false)}
          i18n={i18n}
          data={data}
          client={client}
          clients={clientsToShow}
          searchedClients={searchedClients}
          clientLoading={clientLoading}
          currencyLoading={currencyLoading}
          accountLoading={accountLoading}
          formLoading={formLoading}
          incomeTypesLoading={incomeTypesLoading}
          spendTypesLoading={spendTypesLoading}
          tagsLoading={tagsLoading}
          subcategoriesLoading={subcategoriesLoading}
          demo={demo}
          tutorial={tutorial}
          notifications={notifications}
          logout={(payload) => dispatch(logout(payload))}
          handleClient={(payload) => dispatch(handleClient(payload))}
          getUser={() => dispatch(getUser())}
          finishScenario={(payload) => dispatch(finishScenario(payload))}
          handleEndDemo={() => dispatch(handleEndDemo())}
          handleEndTutorial={() => dispatch(handleEndTutorial())}
          startScenario={(payload) => dispatch(startScenario(payload))}
          form={form}
          setForm={setForm}
          searchLoading={searchLoading}
          setSearchLoading={setSearchLoading}
          handleSearchClients={handleSearchClients}
        />
      )}
    </Fragment>
  );
};

export default Header;
